export default async function (body, url, antiForgeryToken, recaptchaToken) {
  let status = null
  const response = await fetch(url, {
    method: "POST",
    body: JSON.stringify(body),
    headers: {
      "Content-Type": "application/json",
      "RequestVerificationToken": antiForgeryToken,
      "RecaptchaToken": recaptchaToken
    },
  })
    .then((res) => {
      status = res.status
      if (res.ok) {
        return res.text()
      } else {
        throw new Error("Could not fetch salesforce id.")
      }
    })
    .then((json) => {
      return json
    })
    .catch((err) => {
      console.error(err)
      return err
    })

  return {
    data: response,
    status: status,
  }
}
